import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useAemConfig } from '@as-react/common-components';
import { UserVisibility } from '@as-react/common-types';
import { generatePathUrl } from '../util/URLParamUtil';
import { makeGetSessionState } from '../redux/session/selectors/SessionSelector';
import { isLoggedInUser, isLoggedInGuestWebReturns } from '../util/SessionUtil';
const GuestRedirectContainer = ({ visibility }) => {
    const userSession = useSelector(makeGetSessionState());
    const { root } = useAemConfig();
    const redirectToLogin = () => {
        window.location.href = generatePathUrl(root, 'account.html').pathname;
    };
    useEffect(() => {
        var _a;
        if (!((_a = userSession === null || userSession === void 0 ? void 0 : userSession.authorities) === null || _a === void 0 ? void 0 : _a.length))
            return;
        switch (visibility) {
            case UserVisibility.AUTHORIZED:
                !isLoggedInUser(userSession) && redirectToLogin();
                break;
            case UserVisibility.AUTHORIZED_AND_SOFT_LOGGED_IN:
                !isLoggedInUser(userSession) && !isLoggedInGuestWebReturns(userSession) && redirectToLogin();
                break;
            default:
                break;
        }
    }, [userSession]);
    return null;
};
export default GuestRedirectContainer;
